import { useState, useEffect } from 'react'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'

const Hokej = ({ calculatorType = 'Hokej' }) => {
  const [showInputArea, setShowInputArea] = useState(false)
  const [error, setError] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', '', ''],
      teams: ['', '', '', '', '', ''],
    },
    results: {
      winningChances: ['', ''],
      expectedGoals: {
        min: 0,
        avg: 0,
        max: 0,
      },
      exactScore: '0 : 0',
      scoreDifference: '',
      suggestedOver: '',
      teamStrength: {
        home: {
          attack: '',
          defense: '',
        },
        away: {
          attack: '',
          defense: '',
        },
        combined: {
          attack: '',
          defense: '',
        },
        matchup: {
          homeAttack_vs_awayDefense: '',
          homeDefense_vs_awayAttack: '',
        },
      },
    },
  })
  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  const clearFields = () => {
    setData({
      values: {
        odds: ['', '', ''],
        teams: ['', '', '', '', '', ''],
      },
      results: {
        winningChances: ['', ''],
        expectedGoals: {
          min: 0,
          avg: 0,
          max: 0,
        },
        exactScore: '0 : 0',
        scoreDifference: '',
        suggestedOver: ['', ''],
        teamStrength: {
          home: {
            attack: '',
            defense: '',
          },
          away: {
            attack: '',
            defense: '',
          },
          combined: {
            attack: '',
            defense: '',
          },
          matchup: {
            homeAttack_vs_awayDefense: '',
            homeDefense_vs_awayAttack: '',
          },
        },
      },
    })
    setShowInputArea(false)
  }

  const handleButtonClick = () => {
    if (showInputArea) {
      clearFields()
      return
    } else {
      handleCalculate()
    }

    setShowInputArea((prev) => !prev)
  }

  const handleCalculate = () => {
    const [
      domacinDao,
      domacinPrimio,
      brojUtakmicaDomacin,
      gostDao,
      gostPrimio,
      brojUtakmicaGost,
    ] = data.values.teams.map(Number)

    const [kvotaNaKonacanIshod1, kvotaNaKonacanIshodX, kvotaNaKonacanIshod2] =
      data.values.odds.map(Number)

    let snd = domacinDao / brojUtakmicaDomacin
    let sod = domacinPrimio / brojUtakmicaDomacin
    let sog = gostDao / brojUtakmicaGost
    let sng = gostPrimio / brojUtakmicaGost

    let sodg = (sod + sog) / 2
    let sndg = (snd + sng) / 2
    let sndsog = (snd + sog) / 2
    let sodsng = (sod + sng) / 2

    let h63 = parseFloat(kvotaNaKonacanIshod1)
    let k63 = (1 / h63) * 100
    let i63 = parseFloat(kvotaNaKonacanIshodX)
    let j63 = parseFloat(kvotaNaKonacanIshod2)
    let m63 = (1 / j63) * 100
    let l63 = (1 / i63) * 100
    let n63 = k63 + l63 + m63 - 100
    let o63 = k63 - n63 / 3
    let r63 = (o63 * n63) / 100
    let procenatPobede1 = parseFloat(k63 - r63)
    let q63 = m63 - n63 / 3
    let t63 = (q63 * n63) / 100
    let procenatPobede2 = parseFloat(m63 - t63)
    let p63 = l63 - n63 / 3
    let s63 = (p63 * n63) / 100
    let nereseno = parseFloat(l63 - s63)

    let n67 = parseFloat(domacinDao)
    let o67 = parseFloat(domacinPrimio)
    let o69 = parseFloat(brojUtakmicaDomacin)
    let p67 = parseFloat(gostPrimio)
    let q67 = parseFloat(gostDao)
    let q69 = parseFloat(brojUtakmicaGost)
    let l60 = l63 - s63
    let q71 = (p67 + q67) / q69
    let o71 = (n67 + o67) / o69
    let o73 = (o71 + q71) / 2
    let p60 = o73 - o73 * 0.0312
    let golMin = o73 - (l60 / 100) * p60

    let n60 = o73 - (l60 / 100) * p60
    let q59 = p60 - n60 + p60
    let golMax = q59 + q59 * 0.0123

    let golBalans = p60

    let ag60 = procenatPobede1
    let ah60 = nereseno
    let aq60 = p60
    let ar60 = ag60 + ah60 / 2
    let at60 = (aq60 * ar60) / 100
    let bf60
    let k60 = procenatPobede1
    let m60 = procenatPobede2
    let bd60 = p60 / 2
    let ai60 = procenatPobede2
    let as60 = ai60 + ah60 / 2
    let au60 = (aq60 * as60) / 100

    let av60 = Math.round(at60)
    let ax60 = Math.round(au60)

    let max
    let min

    if (av60 > ax60) {
      max = av60
      min = ax60
    } else {
      max = ax60
      min = av60
    }

    let be60 = (max - min) / 5
    let bg60

    if (bd60 > bf60) {
      bg60 = bd60 + be60 / 2
    } else {
      bg60 = bd60 - be60 / 2
    }

    let u59 = (au60 + bg60) / 2

    if (k60 >= m60) {
      bf60 = bd60 + be60 / 2
    } else {
      bf60 = bd60 - be60 / 2
    }

    let t59 = (at60 + bf60) / 2
    let tacanrez1 = Math.round(t59)
    let tacanrez2 = Math.round(u59)

    let r59 = (at60 + bf60) / 2 - (au60 + bg60) / 2
    let pobedaSaRazlikom = r59

    let ay60
    if (av60 > ax60) {
      ay60 = '1'
    } else {
      if (av60 === ax60) {
        ay60 = 'X'
      } else {
        ay60 = '2'
      }
    }

    let betkoPredlog1 = n60
    let o60 = (n60 + p60) / 2
    let betkoPredlog2 = o60

    setData((prev) => ({
      ...prev,
      results: {
        winningChances: [
          procenatPobede1.toFixed(2),
          nereseno.toFixed(2),
          procenatPobede2.toFixed(2),
        ],
        expectedGoals: {
          min: golMin.toFixed(2),
          avg: golBalans.toFixed(2),
          max: golMax.toFixed(2),
        },
        exactScore: `${tacanrez1} : ${tacanrez2}`,
        scoreDifference: `${pobedaSaRazlikom.toFixed(2)} ( ${ay60} )`,
        suggestedOver: [betkoPredlog1.toFixed(2), betkoPredlog2.toFixed(2)],
        teamStrength: {
          home: {
            attack: snd.toFixed(2),
            defense: sod.toFixed(2),
          },
          away: {
            attack: sng.toFixed(2),
            defense: sog.toFixed(2),
          },
          combined: {
            attack: sndg.toFixed(2),
            defense: sodg.toFixed(2),
          },
          matchup: {
            homeAttack_vs_awayDefense: sndsog.toFixed(2),
            homeDefense_vs_awayAttack: sodsng.toFixed(2),
          },
        },
      },
    }))
  }

  return (
    <div className={classesK.container}>
      <InfoBar onRefresh={clearFields} calculatorType={calculatorType} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={handleButtonClick} disabled={disabled}>
            {showInputArea ? 'Unesi obračunske podatke' : 'Prikaži rezultate'}
          </button>
        </div>
        {!showInputArea && (
          <>
            <div className={classesK.sectionTitle}>
              Upiši kvote za ishod utakmice
            </div>
            <OddsCalculator
              data={data.values}
              setData={setData}
              field={'odds'}
              labelPrefix={['KI 1', 'KI X', 'KI 2']}
              type={['number', 'number', 'number']}
              min={['0.1', '0.1', '0.1']}
              step={['0.1', '0.1', '0.1']}
              rows={3}
              setError={setError}
            />
            <div className={classesK.sectionTitle}>
              Upiši br. golova / br. ut. za oba tima
            </div>
            <OddsCalculator
              field={'teams'}
              data={data.values}
              setData={setData}
              labelPrefix={[
                'DOM +  ( dom. dao golova)',
                'DOM -  ( dom. primio golova)',
                'DOM BR. ( dom. odigrao utakmica)',
                'GOST +  ( gost. dao golova)',
                'GOST -  ( gost. primio golova)',
                'GOST BR. ( gost. odigrao utakmica)',
              ]}
              type={[
                'number',
                'number',
                'number',
                'number',
                'number',
                'number',
              ]}
              step={['1', '1', '1', '1', '1', '1']}
              min={['0', '0', '1', '0', '0', '1']}
              rows={3}
              setError={setError}
            />
          </>
        )}
        {showInputArea && (
          <div>
            <div>
              <ResultsSection
                title={'Ishod utakmice'}
                subtitle={'Konačan ishod'}
                results={data.results.winningChances.map(
                  (chance) => `${chance}%`
                )}
                names={['KI 1', 'KI X', 'KI 2']}
                withPercent
              />
              <ResultsSection
                title={'Golovi'}
                subtitle={'Granice golova'}
                names={[
                  'Očekivani minimalni br. golova na utakmici',
                  'Očekivani srednji br. golova na utakmici',
                  'Očekivani maksimalni br. golova na utakmici',
                ]}
                results={[
                  `${data.results.expectedGoals.min}`,
                  `${data.results.expectedGoals.avg}`,
                  `${data.results.expectedGoals.max}`,
                ]}
                rows={2}
                Í
                breakLastItem={true}
              />
              <ResultsSection
                title={'Tačan rezultat'}
                subtitle={'Opcioni tačan rezultat na utakmici'}
                names={['Predikcija tačnog rezultata utakmice']}
                rows={1}
                results={[data.results.exactScore]}
              />
              <ResultsSection
                title={'Pobeda sa razlikom'}
                subtitle={'Očekivana pobeda favorita sa razlikom'}
                names={['Razlika']}
                rows={1}
                results={[data.results.scoreDifference]}
                allowNegative={true}
              />
              <ResultsSection
                title={'Betko predlog'}
                subtitle={'Predlog igre na broj golova'}
                names={[
                  'Predlog prve granice ( + )',
                  'Predlog druge granice ( + )',
                ]}
                rows={1}
                results={[
                  data.results.suggestedOver[0],
                  data.results.suggestedOver[1],
                ]}
              />
            </div>

            <div>
              <ResultsSection
                title={'Snage timova'}
                subtitle={`Snaga domaćina`}
                results={[
                  data.results.teamStrength.home.attack,
                  data.results.teamStrength.home.defense,
                ]}
                withPercent={false}
                names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
              />
              <ResultsSection
                subtitle={`Snaga gosta`}
                results={[
                  data.results.teamStrength.away.attack,
                  data.results.teamStrength.away.defense,
                ]}
                withPercent={false}
                names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
              />
              <ResultsSection
                subtitle={`Snage oba tima zajedno`}
                results={[
                  data.results.teamStrength.combined.attack,
                  data.results.teamStrength.combined.defense,
                ]}
                withPercent={false}
                names={[
                  'SNDG ( snaga napada domaćina i gosta )',
                  'SODG ( snaga odbrane domaćina i gosta )',
                ]}
              />
              <ResultsSection
                subtitle={`Tim proseci odbrana i napada`}
                results={[
                  data.results.teamStrength.matchup.homeAttack_vs_awayDefense,
                  data.results.teamStrength.matchup.homeDefense_vs_awayAttack,
                ]}
                withPercent={false}
                names={[
                  'SND + SOG ( snaga napada domaćin + snaga odbrane gost )',
                  'SOD + SNG ( snaga napada domaćin + snaga odbrane gost )',
                ]}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default Hokej
